import {Component, OnInit, Output, Injectable} from '@angular/core'
import {LeadService} from '../services/lead.service'
import {Router, ActivatedRoute} from '@angular/router'
import {LeadsForm} from '../models/data-model'
import * as moment from 'moment'
import { Location } from '@angular/common'
import {GlobalDataService} from '../../housekeeping/services/global-data.service'

declare var jQuery: any;
@Component({
    selector: 'app-detail',
    templateUrl: '../views/detail.component.html',
    styleUrls: ['../css/detail.component.css']
})

export class DetailComponent implements OnInit {
    public leadno: any;
    public userId = sessionStorage.getItem('userId');
    public leadActivitydesc = "";
    public leadActivityid = "";
    public leadLogDetails: any;
    public showleadLogDetails: boolean = true;
    public showleadActivities:boolean = false;
    public diffdays = 0;
    public showError:boolean = false;
    public showerrorMess = "";
    public currentOwnerLink=false;
    public accordian=false;
    public leadsForm = new LeadsForm ("", "",{},{},{},
      {
                id:null,
                firstName:"",
                lastName:"",
                phone:"",
                adobeIdC: "",
                phoneTimeToCall:"",
                mobile:"",
                mobileTimeToCall:"",
                email:"",
                addressId:{
                           id:null,
                           address1:"",
                           city:"",
                           postalCode:"",
                           stateId:{
                                    id:null,
                                    stateCode:"",
                                    name:""
                                    },
                            countryId:{
                                      id: null,
                                      code:"",
                                      name:""
                                      }
                            },
      assignedTo:{
                id:null,
                userName:"",
                firstName:"",
                lastName:""}
                } ,{},{},{},{},{},{},{},{},new Date(),"","","","","",new Date(),"","","","","","","");
    public city = "";
    public country = "";
    public userTZ='';

    constructor(public _leadService: LeadService, public _router: Router, public activeroute: ActivatedRoute,private location: Location,private _globalService:GlobalDataService) {}

    ngOnInit() {
        window.scrollTo(0, 0);
        this.userTZ = this._globalService.USER_TZ;
        this.activeroute.params.subscribe(
            params => {
                if (Object.keys(params).length != 0) {
                    this.leadno = params.id;
                    this.leadsForm.id = this.leadno;
                    this.getLeadsDetails()

                }
            })
    }
    /**
        * @author Pradeep
        * params leadId,userId
        * @description get the lead data
        */
    getLeadsDetails() {
        this._leadService.viewLeadsDetails(this.leadno, this.userId, (result) => {
            this.leadsForm = result;
//           console.log("result"+JSON.stringify(this.leadsForm))
            if (this.leadsForm.activity.length > 0)
                this.showleadActivities = true;
            if (typeof result.submissionDate != "undefined") {
              const now = moment(); // moment object of now
              const day = moment(result.submissionDate); // moment object of other date
                this.diffdays = now.diff(day, 'days')
            }

            if (this.leadsForm.prospectId.addressId == null) {
            this.leadsForm.prospectId.addressId = {
                           id:null,
                           address1:"",
                           city:"",
                           postalCode:"",
                           stateId:{
                                    id:null,
                                    stateCode:"",
                                    name:""
                                    },
                            countryId:{
                                      id: null,
                                      code:"",
                                      name:""
                                      }
                            }
             }
             if (this.leadsForm.prospectId.addressId.countryId == null) {
                this.leadsForm.prospectId.addressId.countryId={'id': "",'code':"",'name':""}
            }
        })
    }
    /**
       * @author Pradeep
       * params leadId
       * @description get the lead log data
       */
    getLeadLogDetails() {
        this.showleadLogDetails = true;
        this._leadService.getLeadLogDetails(this.leadno, (result) => {
            this.leadLogDetails = result;
            if(this.leadLogDetails.length==0) {
              this.showleadLogDetails = false
            }
        })
    }
    /**
     * @author Pradeep
     * @description edit the lead activity data
     */
    editleadActivities(id, desc) {
        this.leadActivitydesc = desc;
        this.leadActivityid = id
    }

      /**
     * @author Pradeep
     * @description delete the lead activity data
     */
    deleteleadActivities(id,desc) {
        this._leadService.deleteleadActivities(id,(result) => {
           if(result=="DELETED_SUCCESSFULLY"){
                this.getLeadsDetails()
            } else {
                this.showError = true;
                this.showerrorMess = "Something went wrong !!"
            }
        })
    }

     /**
     * @author Pradeep
     * @description save the lead activity data
     */
    saveleadActivities() {
        this.showError = false;
        if(this.leadActivitydesc == "") {
            this.showError = true;
            this.showerrorMess = "Please enter description."
        } else {
          this.showError = false;
          this._leadService.saveleadActivities({"id": this.leadActivityid, "userId": this.userId, "notes": this.leadActivitydesc, "date": new Date(), "leadId": this.leadno, "activityTypeId": 1}, (result) => {

                  if(result=="LEAD_ACTIVITY_SAVED_SUCCESSFULLY"){
                this.leadActivitydesc = "";
                this.leadActivityid="";
                this.getLeadsDetails()
            } else {
                this.showError = true;
                this.showerrorMess = "Something went wrong !!"
            }
          })
        }
    }
     /**
     * @author Pradeep
     * @description redirect to lead edit page
     */
    editlead(leadId) {
        this._router.navigate(['leads/edit/' + leadId])
    }
    /**
     * @author Sowmya
     * @description save lead status
     */
//    saveleadStatus(){
//        this.leadsForm.userId = this.userId;
//        if (this.leadsForm.assignedTo != null && this.leadsForm.assignedTo.id == null) {
//            delete this.leadsForm.assignedTo.id;
//            delete this.leadsForm.assignedTo.userName;
//            delete this.leadsForm.assignedTo.firstName;
//            delete this.leadsForm.assignedTo.lastName;
//            this.leadsForm.assignedTo = null
//        }
//        if (this.leadsForm.dealerId != null && this.leadsForm.dealerId.id == null) {
//            delete this.leadsForm.dealerId.id;
//            delete this.leadsForm.dealerId.superDealerCode;
//            delete this.leadsForm.dealerId.name;
//            delete this.leadsForm.dealerId.globalCode;
//            delete this.leadsForm.dealerId.localCode;
//            delete this.leadsForm.dealerId.regionCode;
//            delete this.leadsForm.dealerId.countryCode;
//            this.leadsForm.dealerId = null
//        }
//        if (this.leadsForm.teamId != null && this.leadsForm.teamId.id == null) {
//            delete this.leadsForm.teamId.id;
//            delete this.leadsForm.teamId.name;
//             this.leadsForm.teamId = null
//        }
//        if (this.leadsForm.prospectId.addressId.stateId !=null && this.leadsForm.prospectId.addressId.stateId.id == null) {
//            delete this.leadsForm.prospectId.addressId.stateId.id;
//            delete this.leadsForm.prospectId.addressId.stateId.name;
//            delete this.leadsForm.prospectId.addressId.stateId.stateCode;
//             this.leadsForm.prospectId.addressId.stateId = null
//        }
//        if (this.leadsForm.prospectId.addressId.countryId !=null && this.leadsForm.prospectId.addressId.countryId.id == null) {
//            delete this.leadsForm.prospectId.addressId.countryId.id;
//            delete this.leadsForm.prospectId.addressId.countryId.name;
//            delete this.leadsForm.prospectId.addressId.countryId.code;
//             this.leadsForm.prospectId.addressId.countryId = null
//        }
//        if (this.leadsForm.sourceId != null  && this.leadsForm.sourceId.id == null) {
//            delete this.leadsForm.sourceId.id;
//            delete this.leadsForm.sourceId.sourceType;
//             this.leadsForm.sourceId = null
//        }
//        if (this.leadsForm.priorityId != null && this.leadsForm.priorityId.id == null) {
//            delete this.leadsForm.priorityId.id;
//            delete this.leadsForm.priorityId.priority;
//             this.leadsForm.priorityId = null
//        }
//        if (this.leadsForm.assignedTo != null && this.leadsForm.intentionId.id == null) {
//            delete this.leadsForm.intentionId.id;
//            delete this.leadsForm.intentionId.intention;
//             this.leadsForm.assignedTo = null
//        }
//        if (this.leadsForm.currentVehicle != null &&this.leadsForm.currentVehicle.id == null) {
//            delete this.leadsForm.currentVehicle.id;
//            delete this.leadsForm.currentVehicle.make;
//            delete this.leadsForm.currentVehicle.model;
//             this.leadsForm.currentVehicle = null
//        }
//        if (this.leadsForm.vehicleOfInterest != null && this.leadsForm.vehicleOfInterest.id == null) {
//             delete this.leadsForm.vehicleOfInterest.id;
//             delete this.leadsForm.vehicleOfInterest.make;
//             delete this.leadsForm.vehicleOfInterest.model;
//             this.leadsForm.vehicleOfInterest = null
//        }
//        if (this.leadsForm.callToAction.id == null) {
//          delete this.leadsForm.callToAction.id;
//          delete this.leadsForm.callToAction.ctaType;
//          this.leadsForm.callToAction = null
//        }
//        if (this.leadsForm.statusId.id == null) {
//           delete this.leadsForm.statusId.id;
//           delete this.leadsForm.statusId.statusType;
//           this.leadsForm.statusId = null
//        } else {
//           this.leadsForm.statusId.id=4;
//           this.leadsForm.statusId.statusType='Closed'
//        }
//        this._leadService.saveLead(this.leadsForm ,(result) => {
//            if(result.statusCodes != "LEAD_SAVED_SUCCESSFULLY"){
//                this.showError = true;
//                this.showerrorMess = "Something went wrong !!"
//            }
////            console.log("updation date"+this.leadsForm.submissionDate)
////            console.log("leadform"+ this.leadsForm.updationDate)
//        this._router.navigate(['leads/detail/' + this.leadno])
//     })
//}
    /**
     * @author Anand
     * @uses    Print the lead details
     */

   printLead(printSectionId: string){
        if(!jQuery(".collapse").hasClass('in')){
          let seeTransaction:HTMLElement = document.getElementById('seeTansactionHistory') as HTMLElement;
          if(seeTransaction!=null) {
            seeTransaction.click()
          }
          let seeMore:HTMLElement = document.getElementById('additionalInfoLink') as HTMLElement;
          if(seeMore!=null) {
            seeMore.click()
          }
        }
        let popupWinindow;
        let innerContents = document.getElementById(printSectionId).innerHTML;
        popupWinindow = window.open('', '_blank');
        popupWinindow.document.open();
        popupWinindow.document.write('<html><head> <link rel="stylesheet" type="text/css" href="../../assets/bootstrap/css/bootstrap.css"> </head><body onload="window.print()">' + innerContents + '</html>');
        popupWinindow.document.close()
  }

  /**
   * @author Anand
   * @uses Scroll to particular element
   */
  scrollToElement(elm){
    if(!jQuery(".collapse").hasClass('in')){
        let seeTransaction:HTMLElement = document.getElementById('seeTansactionHistory') as HTMLElement;
        seeTransaction.click();
     }let scrollElm:HTMLElement = document.getElementById(elm) as HTMLElement;
     setTimeout(function(){
      scrollElm.scrollIntoView({
            behavior: "smooth"
        })
    },500)
  }

  recieveTransactionAck(val){
      if(val)
      this.currentOwnerLink=true;
  }

  /**
   * @author Vanitha
   * @uses To make status closed for lead
   */
  closeLead(leadId){
      this._leadService.closeLead(this.leadsForm ,(result) => {
      if(result == "CLOSED_SUCCESSFULLY" ){
      this.leadsForm.statusId.id=4;
      this.leadsForm.statusId.statusType='Closed'
      }
  })
}}



// WEBPACK FOOTER //
// ./src/app/modules/leads/components/detail.component.ts